
/**
 * Module dependencies.
 */

import {
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  clientId: string,
  projectId: string,
  token: string
};

/**
 * Export `removeProjectClient`.
 */

export async function removeProjectClient(query: Query) {
  const { clientId, projectId, token } = query;
  const endpoint = getApiEndpoint('getUserProjectClient', {
    clientId,
    projectId
  });

  try {
    const { data } = await request.delete(endpoint, {
      headers: authorizationHeader(token)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
